import axios from 'axios'
import store from '@/store'

const API_BASE = 'https://residencial-services.intrare.app'

class ApiError extends Error {
  constructor (message, statusCode, data) {
    super(message)
    this.name = 'ApiError'
    this.statusCode = statusCode
    this.data = data
  }
}

export function extractApiErrorMessage (error) {
  const data = error && error.response && error.response.data
  if (!data) return 'Ocurrió un error al conectar con el servidor'
  if (typeof data === 'string') return data
  if (data.error) return data.error
  if (data.detail) return data.detail
  if (data.non_field_errors) return data.non_field_errors[0]

  const messages = []
  const flatten = (obj, prefix) => {
    Object.keys(obj).forEach(key => {
      const val = obj[key]
      const label = prefix ? `${prefix}.${key}` : key
      if (Array.isArray(val)) {
        val.forEach(v => messages.push(`${label}: ${v}`))
      } else if (val && typeof val === 'object') {
        flatten(val, label)
      } else {
        messages.push(`${label}: ${val}`)
      }
    })
  }
  flatten(data, '')
  return messages.join(' | ') || 'Ocurrió un error al procesar la solicitud'
}

export default {
  /**
   * Crea una invitación desde la oficina
   * POST /invitation/office/create/
   */
  async createInvitation (invitationData) {
    const url = `${API_BASE}/invitation/office/create/`

    try {
      const response = await axios.post(url, invitationData, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      const message = extractApiErrorMessage(error)
      const statusCode = error.response ? error.response.status : null
      const data = error.response ? error.response.data : null
      throw new ApiError(message, statusCode, data)
    }
  },

  /**
   * Obtiene lista de invitaciones de oficina creadas por el empleado actual
   * GET /invitation/office/
   */
  async getInvitations () {
    const url = `${API_BASE}/invitation/office/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      const message = extractApiErrorMessage(error)
      const statusCode = error.response ? error.response.status : null
      const data = error.response ? error.response.data : null
      throw new ApiError(message, statusCode, data)
    }
  },

  /**
   * Obtiene el detalle de un registro InvitationByUsers específico
   * GET /invitation/office/{pk}/
   */
  async getInvitationDetail (invitationByUsersId) {
    const url = `${API_BASE}/invitation/office/${invitationByUsersId}/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      const message = extractApiErrorMessage(error)
      const statusCode = error.response ? error.response.status : null
      const data = error.response ? error.response.data : null
      throw new ApiError(message, statusCode, data)
    }
  },

  /**
   * Busca usuarios ya existentes en la app por nombre, email o teléfono
   * GET /users/filter?search={query}
   */
  async searchUsers (query) {
    const url = `${API_BASE}/users/filter?search=${encodeURIComponent(query)}`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      const message = extractApiErrorMessage(error)
      const statusCode = error.response ? error.response.status : null
      const data = error.response ? error.response.data : null
      throw new ApiError(message, statusCode, data)
    }
  }
}
